import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-subject-master',
  templateUrl: './subject-master.component.html',
  styleUrls: ['./subject-master.component.css']
})
export class SubjectMasterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
